import React from 'react';
import { translate } from 'react-i18next';
import Actions from 'cost_centers/components/list/CostCentersActions';

const CostCentersListRow = ({ costCenter, company, subcompany, permissions, t, handleToggle }) => {
  return (
    <tr>
      <td>{costCenter.key}</td>
      <td>{costCenter.name}</td>
      <td>{costCenter.description}</td>
      <td className="text-center">{t(costCenter.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          permissions={permissions}
          costCenter={costCenter}
          company={company}
          subcompany={subcompany}
          handleToggle={handleToggle}
        />
      </td>
    </tr>
  );
};

export default translate()(CostCentersListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/CostCentersListRow.js